module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-37-36385dac5ad36f0d418eb00230c89c47.svg";